import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout, Header } from 'app/theme/layout'
import ImageHero from 'app/theme/ImageHero'
import guaranteeFAQPageHero from 'assets/img/guarantee-faq-hero.jpg'
import guaranteeFAQPageSVG from 'assets/svg/guarantee.svg'
import NavbarFixed from 'app/theme/NavbarFixed'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import styles from './GuaranteeFAQPage.module.css'

export default function GuaranteeFAQPage() {
  const { openModal, ...modalState } = useModalState()

  const navMenu = [
    {
      title: 'The 100% Roaming Hunger Event Guarantee',
      url: '/food-truck-catering/roaming-hunger-guarantee/',
    },
    {
      title: 'Frequently Asked Questions',
      url: '/food-truck-catering/guarantee-faq/#',
    },
  ]

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>
          The 100% Roaming Hunger Guarantee - Frequently Asked Questions -
          Roaming Hunger
        </title>
        <meta
          name="description"
          content='How does the 100% Roaming Hunger Guarantee process work? If the caterer you booked through Roaming Hunger fails to appear at your event and does not give you or your Roaming ...'
        />
        <meta
          name="og:title"
          content="The 100% Roaming Hunger Guarantee - Frequently Asked Questions"
        />
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <ImageHero
        onButtonClick={openModal}
        imageUrl={guaranteeFAQPageHero}
        description="We guarantee every catering, every time. Because food just tastes better when you have peace of mind."
        title={(
          <div>
            <img
              src={guaranteeFAQPageSVG}
              width="120px"
              className="block mx-auto mb-6"
            />
            The 100% Roaming Hunger Guarantee
          </div>
        )}
      />
      <NavbarFixed menuItems={navMenu} />
      <div className="container my-12">
        <h2 className="font-platform text-3xl md:text-4xl text-navy leading-tight text-center lg:text-left">
          Frequently Asked Questions About the 100% Roaming Hunger Guarantee.
        </h2>
        <p className="font-light text-gray-900 my-4">
          <span className="font-bold">
            How does the 100% Roaming Hunger Guarantee process work? &nbsp;
          </span>
          If the caterer you booked through Roaming Hunger fails to appear at
          your event and does not give you or your Roaming Hunger Agent 24
          hours' notice, and we cannot find you a suitable replacement, we will
          give you 100% of your money back.
          <br />
          In the event that the caterer does not appear during the scheduled
          time, please contact your Roaming Hunger Agent by email and phone. We
          will respond back as soon as we get your message. A request for the
          100% refund must be made within five business days and will generally
          be issued within 30 days.
        </p>
        <p className="font-light text-gray-900 my-2">
          <span className="font-bold">
            How do I submit a Roaming Hunger Guarantee payment request? &nbsp;
          </span>
          Contact your Roaming Hunger Agent who will get the process started and
          tell you when you can expect the refund. If you have other questions
          or concerns that you feel your Roaming Hunger Agent cannot answer,
          please call 1-800-568-9370 or write to us at
          catering@roaminghunger.com.
        </p>
        <p className="font-light text-gray-900 my-2">
          <span className="font-bold">
            How long will it take for my payment request to be processed? &nbsp;
          </span>
          You should receive your refund within 30 days of the request. The
          payment is generally submitted through our accounting department to a
          third party (bank), who then issues the refund.
        </p>
        <p className="font-light text-gray-900 my-2">
          <span className="font-bold">
            I’ve never done food truck catering before, what could possibly go
            wrong? &nbsp;
          </span>
          While instances of non-service are rare, mobile caterers can
          experience issues with traffic, engine problems, kitchen issues, and
          other unforeseen technical issues. If any such day-of issues occur, we
          expect our catering partners to communicate quickly and effectively
          about the issue.
        </p>
        <p className="font-light text-gray-900 my-2">
          <span className="font-bold">
            Can I refuse a replacement and get the guarantee? &nbsp;
          </span>
          If we find a suitable replacement that costs within 20% of your
          original caterer, AND you do not approve the replacement, we will
          refund only the amount of your payment. You would not be eligible for
          the 100% Roaming Hunger Guarantee.
        </p>
      </div>
    </Layout>
  )
}
